import { render } from "./all.vue?vue&type=template&id=68d66a7e"
import script from "./all.vue?vue&type=script&lang=ts"
export * from "./all.vue?vue&type=script&lang=ts"
script.render = render

export default script